<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
name: 'app',
  data:()=>{
    return{
      lang:""
    }
  },
}
</script>

<style>

.home {
  background-color: green;
  padding: 50px;
}
a,p a {
  color: #F04533;;
}
</style>
